import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

export default class DocumentosEstabelecimento extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    componentDidMount() {
        const id = this.props.match.params.id
        const url = `/api/paf/getCpf/${id}`
        axios(url)
            .then(resp => {
                this.setState({ ficha: resp.data })
                this.setState({ loaded: true })
            })
            .catch(error => {
                alert(error)
            })
    }

    updateField(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
    }

    delete(idPaf) {
        let id = this.props.match.params.id
        let dados = {idPaf: idPaf, idUser: localStorage.id, idEstabelecimento: id}
        const url = '/api/paf/deletePaf'
        axios.post(url, dados)
            .then(res => {
                alert(res.data)
                window.location = `/documentosEstabelecimento/${this.props.match.params.id}`
            })
            .catch(error => alert(error.response.data))
    }

    render() {
        if (this.state.loaded) {
            return (
                <React.Fragment>
                    <div className="container">
                        <div className="container mx-auto pt-5">
                            <label className="col-12 mb-5 text-left"><b>{this.state.ficha.cpfCnpj}: {this.state.ficha.estabelecimento}</b></label>
                            <Link to={`/associaProcesso/${this.state.ficha._id}`}>
                                <button className="btn btn-success ml-3">Associar Processo</button>
                            </Link>
                            <Link to={`/novoPaf/${this.state.ficha._id}`}>
                                <button className="btn btn-success ml-3">Novo PAF</button>
                            </Link>
                            <div className="text-center mx-auto">
                                <table className="table mt-4">
                                    <thead>
                                        <tr>
                                            <th>PAF / PROCESSO</th>
                                            <th>SITUAÇÃO</th>
                                            <th>DATA DE CRIAÇÃO</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderRows()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        } else {
            return <div></div>
        }
    }

    renderRows() {
        if (this.state.loaded) {
            let select = []
            this.state.ficha.pafs.map(ficha => {
                let ano = ficha.createdAt.slice(0, 4)
                let mes = ficha.createdAt.slice(5, 7)
                let dia = ficha.createdAt.slice(8, 10)
                let data = dia + "/" + mes + "/" + ano
                let situacao
                if (!ficha.situacao) situacao = "PAF Excluído"
                else situacao = ficha.situacao
                select.push(
                    <tr key={ficha.numero}>
                        <td>{ficha.numero}</td>
                        <td>{situacao}</td>
                        <td>{data}</td>
                        <td>
                            <Link to={`/documentosPaf/${ficha.id}`}>
                                <button style={{
                                    border: "none", backgroundColor: "#28a745",
                                    paddingTop: "5px", paddingBottom: "5px",
                                    paddingLeft: "12px", paddingRight: "12px",
                                    borderRadius: "15px", color: "#FFFF"
                                }}>Abrir</button>
                            </Link>
                            {localStorage.tipo === "interno" ? (
                                <button style={{
                                    border: "none", backgroundColor: "black",
                                    paddingTop: "3px", paddingBottom: "3px",
                                    paddingLeft: "12px", paddingRight: "12px",
                                    borderRadius: "15px", color: "#FFFF", marginLeft: "10px"
                                }} onClick={e => this.delete(ficha.id)}>Excluir</button>
                            ) : (<></>)}
                        </td>
                    </tr>
                )
            })
            this.state.ficha.processos.map(ficha => {
                let ano = ficha.createdAt.slice(0, 4)
                let mes = ficha.createdAt.slice(5, 7)
                let dia = ficha.createdAt.slice(8, 10)
                let data = dia + "/" + mes + "/" + ano
                select.push(
                    <tr key={ficha.numero}>
                        <td>{ficha.numero}</td>
                        <td></td>
                        <td>{data}</td>
                        <td>
                            <Link to={`/documentos/${ficha.id}`}>
                                <button style={{
                                    border: "none", backgroundColor: "#28a745",
                                    paddingTop: "5px", paddingBottom: "5px",
                                    paddingLeft: "12px", paddingRight: "12px",
                                    borderRadius: "15px", color: "#FFFF"
                                }}>Abrir</button>
                            </Link>
                        </td>
                    </tr>
                )
            })
            return select
        }
    }
}